(() => {
	const videos = Array.from(document.querySelectorAll('.video-thumbnail'));
	if( videos.length === 0 ) {
		return;
	}
	
	const classNames = {
		ON: 'status-on',
		OFF: 'status-off',
	};
	
	videos.forEach(wrapper => {
		const video = wrapper.querySelector('video');
		const buttons = Array.from(wrapper.querySelectorAll('.video-control'));
		
		const _toggleButtonState = (btn) => {
			const state = btn.classList.contains(classNames.ON) ? 'on' : 'off';
			_setButtonState(btn, state);
		}
		
		const _setButtonState = (btn, state) => {
			if( state === 'on' ) {
				btn.classList.remove(classNames.ON);
				btn.classList.add(classNames.OFF);
				btn.setAttribute('title', btn.dataset.titleOff);
				return;
			}
			
			btn.classList.remove(classNames.OFF);
			btn.classList.add(classNames.ON);
			btn.setAttribute('title', btn.dataset.titleOn);
		}
		
		buttons.forEach(btn => {
			if( btn.classList.contains('control-sound') ) {
				_setButtonState(btn, video.muted ? 'on' : 'off');
			}
			
			
			btn.addEventListener('click', event => {
				event.preventDefault();
				
				if( btn.classList.contains('control-sound') ) {
					_toggleButtonState(btn);
					video.muted = ! video.muted;
				}
			});
		});
		
		
		video.addEventListener('click', () => {
			video.paused ? video.play() : video.pause();
		})
	});
})();

